/**
 * React Static Boilerplate
 * https://github.com/kriasoft/react-static-boilerplate
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Navigation from './Navigation';
import s from './Header.css';

class Header extends React.Component {

  componentDidMount() {
    // window.componentHandler.upgradeElement(this.refs.root);
  }

  componentWillUnmount() {
    // window.componentHandler.downgradeElements(this.refs.root);
  }

  render() {
    return (
      <header ref="root" className={s.header}>
          <span>BlackYak v0.0.0</span>
          <Navigation />
      </header>
    );
  }

}

export default Header;



/** WEBPACK FOOTER **
 ** ./components/Layout/Header.js
 **/